import React from "react";
import Image from "next/image";
import { Box, Flex, Text } from "rebass/styled-components";
import Heading from "../common/Heading";
import useTranslation from "next-translate/useTranslation";
import { GetDogProfileQuery } from "../../generated/graphql";

interface Props {
  dog: GetDogProfileQuery["dog"];
}

const Observation = ({ dog }: Props) => {
  const { t } = useTranslation("dogprofile");

  return (
    <Flex
      px={[2, 2, 0]}
      sx={{
        flexDirection: "column",
        mt: 3
      }}
    >
      {dog.observations && (
        <Box
          mb={1}
          className="withTail"
          sx={{
            bg: "samoyedWhite",
            border: "1px solid",
            borderColor: "lightGray",
            borderRadius: "4px 4px 4px 4px",
            flexGrow: 1,
            position: "relative",
            px: "2",
            py: "2",
            "&.withTail": {
              "::before": {
                border: "8px solid",
                borderColor: "#EBEBEB transparent transparent #EBEBEB",
                content: `" "`,
                position: "absolute",
                left: "24px",
                bottom: "-16px"
              },
              "::after": {
                border: "7px solid",
                borderColor: "#ffffff transparent transparent #ffffff",
                content: `" "`,
                position: "absolute",
                left: "25px",
                bottom: "-14px"
              }
            }
          }}
        >
          <Text>{dog.observations}</Text>
        </Box>
      )}
      <Flex
        sx={{
          mt: 2
        }}
      >
        <Box sx={{ ".image": { borderRadius: "50%" } }}>
          <Image
            alt={`${dog.name} avatar`}
            src={dog.user.avatar?.circle}
            width="48px"
            height="48px"
            className="image"
            priority
            style={{
              maxWidth: "100%",
              height: "auto"
            }} />
        </Box>
        <Flex
          sx={{
            flexDirection: "column",
            ml: 2
          }}
        >
          <Heading as="h4" variant="highlight">
            {dog.user.name}
          </Heading>
          <Text>
            {t("dogsOwner", {
              dog: dog.name
            })}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Observation;
